import { render } from "./TokenInput.vue?vue&type=template&id=af46f0fe"
import script from "./TokenInput.vue?vue&type=script&lang=js"
export * from "./TokenInput.vue?vue&type=script&lang=js"

import "./TokenInput.vue?vue&type=style&index=0&id=af46f0fe&lang=css"
script.render = render

export default script